import axios from 'axios'
import qs from 'qs';
import { Message } from 'element-ui'
import { Loading } from 'element-ui';
let loading = null;
/**
 * @axios基本配置
 */
axios.defaults.timeout = 15000;
axios.defaults.baseURL = process.env.VUE_APP_API_URL

/**
 * @axios设置全局headers信息
 */
let getHeaders = () => {
  axios.defaults.headers.common['access_token'] = '';
};


/**
 * @请求拦截
 */
axios.interceptors.request.use(config => {
  return config;
}, err => {
  if (loading) {
    loading.close();
    loading = null;
  }
  Message.error({ message: '请求超时!' });
  return Promise.resolve(err);
})

/**
 * @数据返回拦截
 */
axios.interceptors.response.use(data => {
  if (loading) {
    loading.close();
    loading = null;
  }
  if (data.status && data.status == 200 && !data.data.success) {
    Message.error({ message: data.data.message });
    return;
  }
  return data;
}, err => {
  if (loading) {
    loading.close();
    loading = null;
  }
  if (err.response.status == 504 || err.response.status == 404) {
    Message.error({ message: '服务器被吃了⊙﹏⊙∥' });
  } else if (err.response.status == 403) {
    Message.error({ message: '权限不足,请联系管理员!' });
  } else if (err.response.data && err.response.data.message === "Token失效，请重新登录") {
    Message.error({ message: '登录失效，请重新登录!' });
    localStorage.removeItem('ACCESS_TOKEN');
    localStorage.removeItem('USER_NAME');
    localStorage.removeItem('USER_INFO');
    window.location.href = "/"
  } else {
    Message.error({ message: '未知错误!' });
  }
  return Promise.resolve(err);
})


/**
 * @post请求
 * @param url
 * @param params
 * @returns {Promise.<TResult>}
 */
export const post = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios.post(url, qs.stringify(params)).then(res => res.data).catch(error => error);
};

/**
 * @get请求
 * @param url
 * @param params
 * @returns {Promise.<TResult>}
 */
export const get = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios.get(url, { params: params }).then(res => res.data).catch(error => error);
};
/**
 * @put请求
 * @param url
 * @param params
 * @returns {Promise.<TResult>}
 */
export const put = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios({
    method: 'put',
    url,
    params
  }).then(res => res.data).catch(error => error);
};
/**
 * @delete请求
 * @param url
 * @param params
 * @returns {Promise.<TResult>}
 */
export const appDelete = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios.delete(url, { params: params }, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.data).catch(error => error);
};

/****************** application *******************/
export const jsonPost = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios.post(url, JSON.stringify(params), {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.data).catch(error => error);
};
/****************** multipart/form-data上传文件 *******************/
export const uploadFilePost = (url, params, flag = true) => {
  if (flag) {
    loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }
  return axios.post(url, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then(res => res.data).catch(error => error);
};
